var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadimagebutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_31532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12L9 9L6 12",
    stroke: "#004276",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9V15.75",
    stroke: "#004276",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2926 13.7926C16.0241 13.3938 16.602 12.7628 16.935 11.9991C17.268 11.2354 17.3373 10.3825 17.1317 9.57513C16.9262 8.76772 16.4577 8.05174 15.8001 7.54019C15.1425 7.02865 14.3332 6.75066 13.5001 6.75011H12.5551C12.3281 5.87204 11.905 5.05686 11.3176 4.36585C10.7301 3.67485 9.99373 3.126 9.16367 2.76057C8.33361 2.39513 7.43151 2.22263 6.52518 2.25602C5.61886 2.28941 4.73189 2.52784 3.93098 2.95336C3.13006 3.37888 2.43603 3.98044 1.90106 4.7128C1.36609 5.44516 1.00411 6.28926 0.842327 7.18166C0.680545 8.07405 0.723171 8.99151 0.967002 9.86506C1.21083 10.7386 1.64952 11.5455 2.25009 12.2251",
    stroke: "#004276",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_31532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimagebutton);
export default __webpack_public_path__ + "static/media/upload image button.f569939f95653d769d4b142e0e23bff3.svg";
export { ForwardRef as ReactComponent };